import { Component, OnInit,Output,EventEmitter,HostListener, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute,Router } from '@angular/router';
import { Location } from '@angular/common';
import { LinkPatientService } from '../services/link-patient.service';
import { ModalService} from '../services/modal.service';
import { concat as _concat } from 'lodash';
import * as moment from 'moment';
import {AppointmentService} from '../services/appointment.service';
import { SocketService } from '../services/socket.service';
import * as _ from 'lodash';
import { ROUTE_CRM_CALENDAR, ROUTE_LOGIN } from '../app.string';
import { UtilitiesService } from '../services/utilities.service';
import { Subject } from "rxjs";
import { GoogleTagsService } from '../services/google-tags.service';
import { environment } from '@env/environment';
import { AlertService } from '../services/alert.service';
import { EventsService } from '../services/events.service';
import { SESSION_EXPIRED } from '@string';
import { PackageService } from '../services/package.service';
import { CouponService } from "../services/coupon.service";
import { TranslatePipe } from '../pipes/translate.pipe';
import { getLinkedPatientLimitAlertContent, ReusableAlertPopupContent } from '../components/reusable-alert-popup/reusable-alert-popup.const';
import * as AppConstant from '../app.string';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  refresh: Subject<boolean> = new Subject<boolean>();
  private appConfig: any;
  public hasLinkedPatients: boolean;
  public orderdetails: any;
  public isBookAppointment: boolean;
  public isRegisterPatient: boolean;
  public bookingAttributes: any;
  public upcomingAppointments: any;
  public ongoingAppointments: any;
  public consultAgainAppts: any;

  public relationType: any;
  public relations: any;
  public entity: any;
  public linkedId: Array<any>;
  public recordsToLink: Array<any> = [];
  public linkedPatients: Array<any>;
  public isFeedback: boolean;
  public action: string;
  public resource: string;
  public appointmentType: string;
  public isExternalBookAppointment: any;
  public chooseSlot:any;
  public prefillData: Object;
  public facilityList:any;
  public isExpressClinicEnabled: boolean;
  public hidePortalHealthPkg: boolean;


  public openUserProfileActions: boolean;
  public isManageIdentities:boolean;
  public selectedLanguage: string;

  public isConsultNow: boolean;
  public isOnspot: boolean = false;
  public isExpressClinic: boolean;
  public expressdetails: any;

  public openHealthPkgs: boolean;
  public pkgdetails: any;
  public selectedPkg: any;
  public showClinicOpt: boolean;
  public showVideoOpt: boolean;
  public showPersonalOpt: boolean;
  public showHealthOpt: boolean;
  public version1: boolean;
  public version2: boolean;
  public homeServices: boolean;
  public isPatReg: boolean;
  allAppointments: any;
  public openReferrals: Array<any> = [] //referral; API integration yet to done
  public isReferral: boolean = false;
  public referralDetail: any = null;
  public newUI: boolean;
  public enableAlertOnServiceUpdateNotification:boolean=false;
  public unreadAlertCount: number = 0;
  public isMyAlerts: boolean;
  public updateAlertInfo:any;
  public openServiceRequests;
  public isLoggedIn: boolean;
  public patientIdForHealthRecord: any;
  public reportIdForHealthRecord: any;
  public packageOpt: any;
  public packageRefNum: any
  showPreLoginModal: boolean;
  preloginContext: any;
  openMyPackages:boolean;
  showContactusModal;
  openAlertModal;
  public showLinkedPatientLimitPopup: boolean = false;
  public linkedPatientLimitAlertContent: ReusableAlertPopupContent;
  
  // Banner slider properties
  public slides: Array<any> = [];
  public sliderOptions: any = {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.banner-pagination',
      clickable: true,
      type: 'bullets'
    }
  };
  public bannerCardStyle: any = {
    'background': 'transparent'
  };
  public limitToShowHomePageCardList: number = 4;
  public awaitingList: any = [];
  public dashboardConfig: any;
  public actionsList: any;
  private subserviceActionList:any;
  public fetchingActions: boolean = false;
  public allEncounters: any;
  private settledServiceEncounters:any;
  public couponList:any;
  private pendingPayments: Array<any> = [];
  public ordersetId: any;
  public awaitingPackageInfo: any;
  public isOpenAllAwaitingList: boolean = false;
  public docRecommendedServiceDaysLimit: any;
  public activeVisit: any;
  public healthPackages:any;
  public packs: any = [];
  public isWellnessPackageCoupon: boolean = false;
  public canDisableRegister: boolean = false;
  constructor(private user: UserService, private activatedRoute: ActivatedRoute, private location: Location, private linkPatient: LinkPatientService,
    public modalService: ModalService, private appointmentService: AppointmentService, private router: Router, private socket: SocketService, private utils: UtilitiesService, private gtmService: GoogleTagsService,
    private alertService: AlertService,public events:EventsService, private packageService: PackageService, private cdf: ChangeDetectorRef, private couponService: CouponService, private translatePipe: TranslatePipe,) {
    this.version1 = false;
    this.version2 = true;
    this.linkedPatientLimitAlertContent = getLinkedPatientLimitAlertContent(this.translatePipe);

      this.user.setPackages();
      this.selectedLanguage = this.user.currentLanguage;
      this.user.getConfigurationInfo.subscribe(data => {
        console.log('getConfigurationInfo', data);
        this.appConfig = data;
        this.isExpressClinicEnabled = data['pxAppSettings']['enableExpressClinicYn'] == 'Y';
        this.isMyAlerts = data['pxAppSettings']['disableAlertsYn'] != 'Y';
        this.hidePortalHealthPkg = data['pxAppSettings']['hidePortalHealthPackage'] == 'Y' ? true : false;
        this.limitToShowHomePageCardList = data['pxAppSettings']['limitToShowHomePageCardList'] ? parseInt(data['pxAppSettings']['limitToShowHomePageCardList']) : 4;
        // Initialize slides data (similar to company-description logic)
        this.initializeSlides(data);
      })
      this.user.getUserInfo('linkedPatients').subscribe(data => {
        this.linkedPatients = data
      });
      if (Array.isArray(this.linkedPatients) && this.linkedPatients.length){
        this.linkedPatients.map(p => {
          let payload = {
            entityId: p.entityid,
            uhid: [p['uhid']]
          }
          this.socket.joinPatientEvent(payload);
        });
      }
      this.socket.onAppointmentChange().subscribe( obj => {
        this.fetchUpcomingAppointment();
      })
  }

  ngOnInit() {
    this.newUI = (environment['ENTITY'] && environment['ENTITY'] == 'MOHEGY') ? true : false;
    this.isLoggedIn = this.user.isLoggedIn();
    this.user.getConfigurationInfo.subscribe(data => {
      if(data.pxAppSettings){
        if(data.pxAppSettings.onSpotConsultationYn == 'Y'){
          this.isOnspot = true;
        }
        else{
          this.isOnspot = false;
        }
      }
    });
    this.canDisableRegister = this.user.canDisableRegister();
    this.checkUrl();
    if (this.isLoggedIn) {
      this.user.getUserInfo('linkedPatients').subscribe(data => {
        this.hasLinkedPatients = data.length > 0 ? true : false;
      });
      this.fetchUpcomingAppointment();
      this.pageInitialLoad();
      if(this.user.canViewOption('ENABLERECENTLYCONSULTEDVIEW')) {
        this.getConsultAgain();
      }
      this.dashboardConfig = this.user.getDashboardConfig();
      let res = this.dashboardConfig.content.options.filter(a => a.type == 'predefinedTemplate')
      if (res && res.find(b => b.config.type == 'AWAITINGLISTAPPTS')) {
        this.getAwaitingActionList();
      }
      this.initLinkedRecords();
      this.getPatientsToLink();
      // let isFromPackage = this.user?.getIsFromPackage();
      // if(isFromPackage) {
      //   console.log('Navigating to My Packages from Home as isFromPackage is true', 'this.user?.getAppointmentRefNum()', this.user?.getAppointmentRefNum(), 'this.user?.getApptConfirmationDetails()', this.user?.getApptConfirmationDetails());
      //   if(this.user?.getAppointmentRefNum()) {
      //     this.navigateToCalendar();
      //   } else if(this.user?.getApptConfirmationDetails()) {
      //     this.redirectToMyPackage(this.user?.getApptConfirmationDetails());
      //   } else {
      //     this.navigateToCalendar();
      //   }
      // }
    }
    this.showErrorModal();
    
  }


  public pageInitialLoad() {  
    const data = this.user.getUpdateInfoSync('directives');
    if (data) {
      data.userDefined.find(def => { 
        if(def.directiveGroup == 'HOSPSERV'){
          this.user.setStorage(AppConstant.HEALTHPKG_LIST, JSON.stringify(def));
          
          this.packs.push(_.cloneDeep(def));
          // if(this.packs['concepts'].length >3)
          // this.packs['concepts'].length = 3;
        }
      })
      this.getAllHealthPackages(this.packs)
    }
  }

  private getAllHealthPackages(packs) {
    let healthPackages = packs || [];
    console.info('healthPackages', healthPackages);
    let allPackages = []
    let packages = allPackages?.length ? allPackages : healthPackages
    this.packageService.setAllPackages(packages);
    console.info('packages>>>>>', packages);
    let reducedHealthPackages = packages.reduce((r, a) => {
      let pack, concepts = [];
      if (a._directiveRef) {
        pack = _.cloneDeep(a._directiveRef);
        delete a._directiveRef
        concepts = [a];
      } else {
        pack = a;
        concepts = a.concepts;
      }
      let packHead = {
        code: pack.code,
        directiveGroup: pack.directiveGroup,
        facilities: pack.facilities,
        sysDef: pack.sysDef,
        name: pack.name,
        imageUrl: pack.imageUrl,
        expanded: pack.expanded,
        canRequest: pack.canRequest,
        isPackageApplicable:pack.isPackageApplicable
      }
      concepts.forEach(concept => {
        if(concept && concept['name'] && concept['name'].length > 0){
          let _name = concept['name'].find(t => {
            return t.locale == this.user.getCurrentLanguage()
          })
          concept['pkgName'] = _name ? _name['name'] : ""
        }else {
          concept['pkgName'] = concept['name'] ? concept['name'] : ""
        }
        if (concept.packageDtls && (concept.packageDtls.isPackageApplicable && concept.packageDtls.isPackageApplicable == 'Y')) {
          r.push({
            package: _.cloneDeep(packHead),
            concept: _.cloneDeep(concept)
          })
        }
      })
      return r;
    }, [])
    //hardcoded HLTHPKGS directive only to show in home page as display priority changes not included in 8.1.9.0
    reducedHealthPackages = reducedHealthPackages.filter(p => (p.package && p.package.isPackageApplicable && p.package.isPackageApplicable == 'Y')).sort((a, b) => {a['_displayPriority']-b['_displayPriority']})
    reducedHealthPackages = _.orderBy(reducedHealthPackages, ["concept['_displayPriority']", "concept['pkgName']"], ["asc", "asc"])
    console.info('reducedHealthPackages', reducedHealthPackages)
    this.healthPackages = reducedHealthPackages;
  }


  checkUrl() {
    this.activatedRoute.queryParams.subscribe(params => {
      console.info('activatedRoute checkUrl', params)
      let payment = params['s'];
      let action = params['action'];
      let resource = params['resource'];
      let speciality = params['speciality'];
      let facility = params['facility'];
      let slot = params['slot'];
      let isPatReg = params['regPat'] == 'Y'
      let type = params['type'];
      let alias = params['alias'];
      let patientId = params['patientid']
      let reportId = params['reportid']
      let pcode = params['pcode']; // Extract promo code for deeplink
      if (payment == 1) {
        let method = params['method'];
        let orderdetails = params['p'];
        switch (method) {
          case 'APPTBK':
            this.orderdetails = orderdetails;
            this.openBookAppointment();
            this.location.replaceState('/portal/home')
            break;
          case 'EXPRESS':
            this.orderdetails = orderdetails;
            this.openExpressClinic(true);
            this.location.replaceState('/portal/home')
            break;
          case 'SRVREQ':
            this.selectedPkg = null;
            this.pkgdetails = orderdetails;
            this.openHealthPkgs = true
            this.location.replaceState('/portal/home')
            break;
          case 'PATREGN':
            this.openModal('manage-identity-modal');
            this.location.replaceState('/portal/home')
            break;
        }
      }
      else if (action == 'schedule') {
        //example https://healtht.nahdi.sa/at/patientportal/#/login?action=schedule&type=express
        console.log("tyoe", params)
        if (type && type.toLowerCase() == 'onspot') {
          this.openAppointment('VIDEO-CONSULT-NOW', { speciality, pcode })
          this.location.replaceState('/portal/home')
        } else if (type && type.toLowerCase() == 'express') {
          this.openExpressClinic();
          this.location.replaceState('/portal/home')
        } else if (type && type.toLowerCase() == 'healthpackages') {
          this.openHealthPkgs = true
          this.location.replaceState('/portal/home')
        } else if (type && type.toLowerCase() == 'homecare') {
          this.homeServices = true;
          this.location.replaceState('/portal/home')
        } else {
          this.chooseSlot = {
            resourceId: resource,
            facilityId: facility,
            appointmentType: type,
            specialityId: speciality,
            slot:slot,
            alias:alias
          }
          this.openBookAppointment();
          this.location.replaceState('/portal/home');
        }
      } else if (action == 'registerpatient') {
        this.openRegisterPatient();
        this.location.replaceState('/portal/home')
      } else if (action == 'home') {
        this.location.replaceState('/portal/home')
      } else if(action == 'reports') {
        this.patientIdForHealthRecord = patientId;
        this.reportIdForHealthRecord = reportId;
        this.openHealthRecords()
        this.location.replaceState('/portal/health-records')
      } else if(action == 'healthrecords') {
        this.patientIdForHealthRecord = patientId;
        this.openHealthRecords()
        this.location.replaceState('/portal/health-records')
      }
      else if(resource){ 
        this.chooseSlot = {
          resourceId: resource,
          facilityId: facility,
          appointmentType: type
        }
      }

      if (isPatReg) {
        setTimeout(_ => {
          this.isPatReg = true
          this.openModal('manage-identity-modal');
          this.location.replaceState('/portal/home')
        }, 500)
      }
    });
  }
  
  public openAppointment( appointmentType, deeplinkParams = null){
    if(appointmentType == 'VIDEO-CONSULT-NOW' && !this.isLoggedIn)
      return this.showLoginAlert({action:'schedule', type:'onspot'});
    this.prefillData = { 
      type: appointmentType,
      deeplinkParams: deeplinkParams 
    };
    this.openBookAppointment();

    let obj = {
      'event': 'clinic_appointment_button',
      'funnel_name': 'Clinic Appointments',
    };
    if (appointmentType == 'VIDEO') {
      obj['event'] = 'online_consultation_button';
      obj['funnel_name'] = 'Online Consultation';
    }
    if (appointmentType == 'VIDEO-CONSULT-NOW') {
      obj['event'] = 'consult_doctor_now_button';
      obj['funnel_name'] = 'Instant Consultation';
    }
    this.gtmService.pushGTMEvent(obj['funnel_name'], obj['event']);
  }

  public openHealthRecords() {
    console.info('openHealthRecords',this.patientIdForHealthRecord, this.reportIdForHealthRecord)
    if(this.patientIdForHealthRecord && this.reportIdForHealthRecord) {
      this.router.navigate([`${this.user.getPortalBasePath()}/`+ 'health-records', {action: 'reports', id: this.patientIdForHealthRecord, reportId: this.reportIdForHealthRecord}])
    } else if(this.patientIdForHealthRecord) {
      this.router.navigate([`${this.user.getPortalBasePath()}/`+ 'health-records', {action: 'healthrecordreport', id: this.patientIdForHealthRecord}])
    } else {
      this.router.navigate([`${this.user.getPortalBasePath()}/`+ 'health-records', {action: 'healthrecords'}])
    }
  }

  closeApptDetail() {
    this.isBookAppointment = false;
  }
  public openBookAppointment() {
    this.isBookAppointment = true;
  }
  public openExpressClinic(isFromRoute?) {
    if (!this.isLoggedIn)
    return this.showLoginAlert({action:'schedule', type:'express'});
    this.isExpressClinic = true;
    if (!isFromRoute)
      this.gtmService.pushGTMEvent('Express Clinics', 'express_clinics_button');
  }
  public closeExpressClinic(){
    this.isExpressClinic = false;
    this.orderdetails = null;
    this.bookingAttributes = null;
  }
  public closeBookAppointment(event) {
    this.isBookAppointment = false;
    this.orderdetails = null;
    this.chooseSlot = null;
    this.prefillData = null;
    if(!event){
      return
    }
    if (event.bookingAttributes) {
      this.bookingAttributes = event.bookingAttributes;
      this.openRegisterPatient();
    } else if(event == 'EXPRESS') {
      this.isExpressClinic = true;
    } else if(event == 'HOME-CARE') {
      this.homeServices = true;
    } else {
      this.fetchUpcomingAppointment();
      this.getConsultAgain();
      this.bookingAttributes = null;
      this.chooseSlot = null;
      this.isReferral = false;
      this.referralDetail = null;
      this.router.navigate([`../${ROUTE_CRM_CALENDAR}`], { relativeTo: this.activatedRoute });
    }
  }
  public openRegisterPatient() {
    if (!this.isLoggedIn)
      return this.showLoginAlert({ });
    if (this.user.canDisableRegister()) {
          console.log('openRegisterPatient canDisableRegister', this.user.canDisableRegister());
      this.showLinkedPatientLimitPopup = true;
      return;
    }
    this.isRegisterPatient = true;
  }
  public closeRegisterPatient() {
    this.isRegisterPatient = false;
    if (this.bookingAttributes) {
      this.openBookAppointment()
    }
  }

  public navigateToCalendar() {
    if(!this.isLoggedIn)
    return this.showLoginAlert();
    this.router.navigate([`../${ROUTE_CRM_CALENDAR}`], { relativeTo: this.activatedRoute });
  }
  public getAppointments() {
    this.user.getUpcomingAppointments().subscribe(data => {
      this.upcomingAppointments = data.data['appointments'];
      this.ongoingAppointments = data.data['appointments'];
    })
  }

  private getRelationList() {
    this.user.getMasterConfig.subscribe(data => {
      this.relationType = data.list;
      this.relationType = this.relationType.filter(arr => {
        return arr.domain === 'RELATIONSHIP_TYPE'
      })
      this.relations = this.relationType[0].codes
    });
  }

  private getEntityId() {
    this.user.getConfigurationInfo.subscribe(data => {
      this.entity = data.entityId;
    })
  }

  private getLinkedPatient() {
    this.user.getUserId().subscribe(data => {
      if (data) {
        this.linkPatient.getLinkedPatient(data).subscribe(result => {
          if (result.status === 'SUCCESS') {
            this.linkedPatients = result.data;
            this.getPatientsToLink();
          }
        })
      }
    })
  }

  private getPatientsToLink() {
    if(this.linkedPatients){
      this.linkedId = this.linkedPatients.map(item => {
        return item.uhid;
      })
    }
    this.user.getUserCredential().subscribe(data => {
      if (data) {
        this.linkPatient.getPatientsToLink(data).subscribe(result => {
          if (result.status === 'SUCCESS') {
            this.recordsToLink = result.data.filter((item) => {
              return this.linkedId.indexOf(item.patientUhid) === -1
            });
          }
        })
      }
    })
  }
  public initLinkedRecords() {
    this.getLinkedPatient();
    this.getEntityId();
    this.getRelationList();
    this.canDisableRegister = this.user.canDisableRegister();
  }
  public openFeedbackForm() {
    this.isFeedback = true;
  }
  public closeFeedbackForm() {
    this.isFeedback = false;

  }

  openModal(id: string) {
    if (id == 'manage-identity-modal') {
      if(!this.isLoggedIn)
      return this.showLoginAlert();
      // this.isManageIdentities = true;
      this.user.getUserId().subscribe(data => {
        if (data) {
          this.linkPatient.getLinkedPatient(data).subscribe(result => {
            console.log('getLinkedPatient', result)
            if (result.status === 'SUCCESS') {
              this.linkedPatients = result.data;
              if(this.linkedPatients && this.linkedPatients.length > 0) {
                this.isManageIdentities = true;
                this.modalService.open(id);
              }else
                return null;
            }
          })
        }
      })
    }else
    this.modalService.open(id);
  }

  closeModal(id: string) {
      this.modalService.close(id);
  }

  public openUserActions() {
    if(!this.isLoggedIn)
    return this.showLoginAlert();
    this.openUserProfileActions = true;
  }
  
  public closeUserActions() {
    this.openUserProfileActions = false;
    this.refresh.next(true);
  }

  public openHealthPkg(packag?) {
    this.packageService.clearAllValues();
    if (!this.isLoggedIn) return this.showLoginAlert();
    console.log('openHealthPkg', packag);
    if(packag?.click == 'SEEALLHEALTHPACKAGES') {
      this.user.setPackageClassificationType(packag?.options)
    } else if(packag?.click === 'WELLNESS' || packag?.click === 'PROMO') {
      this.user.setPackageClassificationType(packag?.options);
    }
    this.packageService.setValue('classification', packag?.options?.classification)
    this.packageService.setValue('isHealthPackage', true);
    this.selectedPkg = packag;
    this.pkgdetails = null;
    this.openHealthPkgs = true;
    this.gtmService.pushGTMEvent('Health Packages', 'health_packages_button');
    // this.switchLanguage = false;
  }
  public closeHealthPkg(event) {
    this.openHealthPkgs = false;
    if(this.user?.getAppointmentRefNum()) {
      this.navigateToCalendar();
    } else if(this.user?.getApptConfirmationDetails()) {
      this.redirectToMyPackage(this.user?.getApptConfirmationDetails());
    } else if(this.isWellnessPackageCoupon) {
      this.isWellnessPackageCoupon = false;
    } else if(event != 'CLOSE') {
      this.navigateToCalendar();
    }
  }

  public redirectToMyPackage(event) {
    this.openHealthPkgs = false;
    this.openMyPackages = true;
    this.packageRefNum = event?.apptRefNumber
  }

  public closeManageIdentities() {
    this.isManageIdentities = false;
  }

  fetchUpcomingAppointment() {
    this.user.getUserId().subscribe(data => {
      if (data) {
        this.appointmentService.getUpcomingAppointment(data).subscribe(result => {
          this.upcomingAppointments = this.allAppointments = result.data.appointments;
          let today= this.user.getMoment().format('DD/MM/YYYY');
          let nextAppointments = this.upcomingAppointments.filter(a => {
            if(this.user.getMoment(a.appointmentDateTime,'YYYY-MM-DD HH:mm').isAfter(this.user.getMoment(today,'DD/MM/YYYY'),'day')) return a;
          }).splice(0,4)
          this.upcomingAppointments = this.upcomingAppointments.filter((a)=>{//2020-04-23 08:00
              if(this.user.getMoment(today,'DD/MM/YYYY').isSame(this.user.getMoment(a.appointmentDateTime,'YYYY-MM-DD HH:mm'),'day')) return a;
          })
          this.ongoingAppointments = this.upcomingAppointments.filter((a)=>{
            if(a.consultationStatus && a.consultationStatus =='PAUSE' || a.consultationStatus =='STARTED') {
              return a;
            }
          })
          this.upcomingAppointments = this.upcomingAppointments.filter((a)=>{
              if(!a['consultationStatus'] || (a.consultationStatus && a.consultationStatus !='FINISH' && a.consultationStatus !='CANCEL' && a.consultationStatus !='PAUSE' && a.consultationStatus !='STARTED' )) {
                return a;
              }
          })
          // this.upcomingAppointments = this.upcomingAppointments.filter((a)=>{
          //     var apptDate = new Date(this.user.getMoment(a.appointmentDateTime, 'YYYY-MM-DD HH:mm').toDate())
          //     if(this.user.getMoment(apptDate).isAfter(this.user.getMoment().format())) {
          //       return a;
          //     }
          //     else {
          //       if(a['appointmentType']=='VIDEO'){
          //          return this.allowJoin(a)
          //       }else{
          //         return this.showCheckIn(a);
          //       }
          //     }

          // })
          this.upcomingAppointments = _concat(this.upcomingAppointments, nextAppointments);
          console.log('getConsultAgain', this.upcomingAppointments);
          this.upcomingAppointments = this.upcomingAppointments.slice(0, this.limitToShowHomePageCardList);
        })
      }
    })
  }

  public openBookSubServiceAppointment(event) {
    console.log('openBookSubServiceAppointment', event);
    if(event?.actionType === 'PACKSUBSERVICE') {
      this.ordersetId = event?.orderSetId;
      this.awaitingPackageInfo = event;
      this.openMyPackages = true;
    } else if(event?.viewType === 'PACKAGECOUPON') {
      console.log('openBookSubServiceAppointment for coupon', event?.packageData?.concept);
        if(event?.packageData?.concept) {
          this.selectedPkg = event?.packageData?.concept;
          this.selectedPkg['selectedFacilityId'] = 'JA';
          this.isWellnessPackageCoupon = true;
          this.openHealthPkgs = true;
        }
    }
  }

  getConsultAgain() {
    this.user.getUserId().subscribe(data => {
      if (data) {
        this.appointmentService.getRecentlyConsultedAppts(data).subscribe((res) => {
          console.log('getConsultAgain', res)
          this.consultAgainAppts = res;
        })
      }
    });
  }

  public openAllAwaitingActionList() {
    this.isOpenAllAwaitingList = true;
  }

  public closeAwaitingList() {
    this.isOpenAllAwaitingList = false;
  }

  public getAwaitingActionList() {
    // if (this.fetchingActions) return
    // this.fetchingActions = true
    let patientList = this.linkedPatients;
    let tmp=[];
    let mobileNumber = this.user.getPersonMobile()
    patientList.forEach((p)=>{
      tmp.push(p['uhid']
      )
    })
    let inparam={
      "patientIds":tmp
    }
    let params = {
      patientsIds : tmp.join(',')
    }

    let couponParams={
      loyaltyId: this.user.getloyaltyId(),
      isBackgroundProcess: true,
      isPackage: false,
      source: 'DASHBOARD',
      mobile:this.user.getPersonMobile(),
      countryCode:this.user.getPersonCountryCode(),
    }
    this.actionsList=[]
    if (tmp?.length > 0 && mobileNumber) {
      this.user.getAwaitingActionList(inparam, true).subscribe(data => {
        if (data?.length > 0) {
          data.forEach((action) => {
            action['actionType'] = 'PACKSUBSERVICE';
            action['_patientObj'] = patientList.find(p => p.uhid == action.patientId)
            if (action.serviceInd == 'LB') {
              action['_icon'] = 'LAB'
            } else if (action.serviceInd == 'RD') {
              action['_icon'] = 'RAD'
            } else {
              action['_icon'] = 'CONSULT'
            }
          })
          this.subserviceActionList = this.parseActionList(data)
          console.info('subserviceActionList', this.subserviceActionList)
          this.generateActionList()
        }
      })
      if (this.user.canViewOption('DISABLERECOMMENDEDSERVICEAPPOINTMENT')) {
        this.allEncounters = []
      } else {
        this.user.getAllUnbilledEncounters(tmp.join(','), this.user.getPersonMobile(), true).subscribe(unbilledEncounters => {
          this.docRecommendedServiceDaysLimit = this.user.canViewOption('DOCTORRECOMMENDEDSERVICEDAYSLIMIT');
          if (unbilledEncounters?.apptReqDermaServices) {
            this.user.setApptReqDermaServices(unbilledEncounters.apptReqDermaServices)
          } else {
            let dermaServices = 'DTPR0800,PKPL000050,PKPL000029,PKPL0409,PKPL0406,DTLS00010,DTPR00011,DTLS07764,DTLS07763,DTPR0101,DTPR0098,DTPR0099,DTPR0105,DTPR0106,DTPR0104,DTPR0108,DTPR0096,DTPR0100,DTPR0103,DTPR0097,DTPR0107,DTPR0064,DTPR0109,DTPR0059,DTPR0060,DTPR0038,DTPR0039,DTPR0040,DTPR0113,DTPR0035,DTPR0036,DTPR0037,DTPR0110,DTPR0148,PKPL000066,DTPR0823,DTPR0825,DTPR0824,DTPR0194,DTPR0212,DTPR0121,DTPR0043,DTPR0044,DTPR0063,DTPR0045,PKPL000051,PKPL0407,DTPR07769,DTPR0111,DTPR0112,DTPR0147,DTPR0150,DTPR0838,DTPR2020,PKPL0411,DTPR0363,PKPL000065,DSPR0003,DSPR0002,DSPR0006,PKPL0408,PKPL0412,DSPR0001,DSPR0008,DSPR0007,PKPL000064'
            this.user.setApptReqDermaServices(dermaServices)
          }
          if (unbilledEncounters?.apptReqConsultServices) {
            this.user.setApptReqConsultServices(unbilledEncounters.apptReqConsultServices)
          } else {
            let consultServices = ''
            this.user.setApptReqConsultServices(consultServices)
          }
          if (unbilledEncounters.restrictApprovalCode) {
            this.user.setRestrictApprovalCode(unbilledEncounters.restrictApprovalCode);
          }
          if(unbilledEncounters?.directivesSplitIntosubdirectiveCategory){
            this.user.setDirectivesSplitIntosubdirectiveCategory(unbilledEncounters.directivesSplitIntosubdirectiveCategory);
          }
          if (unbilledEncounters.restrictApprovalStatusCode) {
            this.user.setRestrictApprovalStatusCode(unbilledEncounters.restrictApprovalStatusCode);
          }
          if (unbilledEncounters.encounters && unbilledEncounters.encounters.length > 0) {
            if (!this.user.canViewOption('ENABLEINSURANCEBILLING'))
              unbilledEncounters.encounters = unbilledEncounters.encounters.filter(encounter => encounter?.billingGroupId == 'CASH' || encounter.billingGroup == 'CASH')
          }
          if (unbilledEncounters?.encounters && unbilledEncounters.encounters.length > 0)
            unbilledEncounters.encounters.forEach(encounter => {
              encounter.viewType = 'DOCRECSERVICELIST';
            })
          this.allEncounters = unbilledEncounters.encounters.map(item => {
            const match = this.linkedPatients?.find(linked => linked.uhid === item.patientId);
            return { ...item, patientDetails: match, resourceAvatarURL: null };
          });
          this.activeVisit = _.cloneDeep(unbilledEncounters.encounters);
          const currentDate = moment();
          this.allEncounters = this.allEncounters.filter(encounter => {
            const visitDate = moment(encounter.visitDate);
            const daysLimit = visitDate.add(this.docRecommendedServiceDaysLimit, 'days');
            return daysLimit.isSameOrAfter(currentDate, 'day');
          });
          this.user.setEncounterList(this.allEncounters);
          console.info('unbilled encounter', this.allEncounters)
          this.generateActionList()
        })
      }
      this.user.getErVisits(params, true).subscribe(erServices => {
        if (erServices?.length > 0) {
          erServices = erServices.sort((a, b) => {
            return (
              new Date(moment(b.dttm, 'YYYY-MM-DD HH:mm').format()).getTime() -
              new Date(moment(a.dttm, 'YYYY-MM-DD HH:mm').format()).getTime()
            );
          })
          erServices = erServices.filter(d => {
            if (moment(d.dttm).isSame(moment(), 'd')) {
              return d;
            }
          })
          erServices.forEach((visit) => {
            visit.patientDetails = this.user.getPatientByPatientId(visit.uhid || visit.patientId)
            // visit._headerType='ER';
            visit._headerType = 'CLINIC';
            let specs = this.user.canViewOption('ERAPPLICABLESPECS') || []
            if (specs.includes(visit.specialityCode)) {
              visit._headerType = 'ER';
            }
            visit.viewType = 'ERSERVICELIST';
            if (visit['billingGroupCode'] == 'CASH') {
              if ((visit['paidAmount'] > 0 && visit['receiptNo']) || !visit['paidAmount']) {
                visit['_serviceStatus'] = 'P';
              }
            } else {
              if (visit['paidAmount'] > 0 && visit['paidAmount'] != visit['totalAmount']) {
                visit['_serviceStatus'] = 'PA';
              } else if (visit['paidAmount'] > 0 && visit['paidAmount'] == visit['totalAmount']) {
                visit['_serviceStatus'] = 'A';
              }
            }
            this.settledServiceEncounters = erServices;
            console.info('settledServiceEncounters', this.settledServiceEncounters)
            this.generateActionList()
          })
        }
      })
      this.couponService.getCoupons(couponParams).subscribe(couponData => {
        if (couponData?.data.length > 0) {
          couponData.data.forEach((c) => {
            c.viewType = 'PACKAGECOUPON';
          })
          this.couponList = couponData.data;
          this.couponList = this.couponList.filter(c => {
            if (c['wellnessCouponInfo'])
              return c;
          })
          this.couponList.forEach(c => {
            c.packageData = this.healthPackages.find(pack => pack?.concept?.code === c['wellnessCouponInfo']['code'])
          })
          console.info('coupon data', this.couponList)
          this.generateActionList()
        }
      })
    }
  }

  private parseActionList(data){
    let packages = this.user.getDirectiveByDirectiveGroup('HEALTHPACKAGES');
    data.forEach((action)=>{
      if(action.actionType=='PACKSUBSERVICE'){
        (packages || []).forEach(pack => {
          pack.concepts.forEach(concept => {
            if(concept.code==action.packageCode)
              action['packageInfo']={
                packageObject:_.cloneDeep(concept)
              };
          })
        })
      }
    })
    this.awaitingList = data;
    console.log('actionsList', this.awaitingList);
    this.fetchingActions = false;
    return this.awaitingList;
  }

  private generateActionList(){
    const final=[];
    let arr1=[],arr2=[],arr3=[],arr4=[], arr5=[];
    if(this.subserviceActionList?.length>0){
      final.push(this.subserviceActionList[0]);
      arr1=this.subserviceActionList.slice(1)
    }
    if(this.allEncounters?.length>0){
      final.push(this.allEncounters[0])
      arr2=this.allEncounters.slice(1)
    }
    if(this.settledServiceEncounters?.length>0){
      final.push(this.settledServiceEncounters[0])
      arr3=this.settledServiceEncounters.slice(1)
    }
    if(this.couponList?.length>0){
      final.push(this.couponList[0])
      arr4=this.couponList.slice(1)
    }
    console.log('pendingPayments', this.pendingPayments)
    if (this.pendingPayments?.length>0){
      final.push(this.pendingPayments[0])
      arr5 = this.pendingPayments.slice(1)
    }

    const remaining = [...arr1, ...arr2, ...arr3, ...arr4, ...arr5]
    while(final.length<6 && remaining.length){
      final.push(remaining.shift())
    }
    console.info('await--list',final)
    this.fetchingActions = false;
    this.actionsList = final.slice(0, this.limitToShowHomePageCardList);//[...actions,...this.allEncounters]
    console.log('generateActionList', this.actionsList);
    this.cdf.detectChanges();
  }

  public openRCAppointment() {
    console.log('openingggg')
  }


      showCheckIn(apt){
        // Use sync access since data should already be loaded
        const data = this.user.getUpdateInfoSync('facilities');
        this.facilityList = data && data.facilities ? data.facilities : [];
        if (this.appConfig.features.appointmentCheckIn) {
          if (apt.checkedIn == 'false' && apt.checkInAllowed == 'true') {
            for (let f in this.facilityList) {
              if (this.facilityList[f].facilityId == apt.facilityId) {
                if (this.validateRule(apt.appointmentDateTime, this.facilityList[f].facilityControls.schedulingRules.checkInPolicy, apt['facilityId'])) {
                  return true;
                } else {
                  return false;
                }
              }
            }

          } else {
            return false;
          }
        } else {
          return false;
        }
    }

      allowJoin(apt){
        // Use sync access since data should already be loaded
        const data = this.user.getUpdateInfoSync('facilities');
        this.facilityList = data && data.facilities ? data.facilities : [];
        this.facilityList = this.facilityList.filter( item =>{
          return item['facilityId'] == apt['facilityId']
        })
        var policy=this.facilityList[0];
        if(policy && policy.facilityControls && policy.facilityControls.schedulingRules){
          var rules = policy.facilityControls.schedulingRules;
          if (apt.isOnspot) {
            if (rules?.onspotConsult?.policy) {
              let dateTimeToCheck = this.user.getMoment(apt['appointmentDateTime'], 'YYYY-MM-DD HH:mm');
              if (this.validateRule(dateTimeToCheck, rules.onspotConsult.policy, apt['facilityId'])) {
                return true;
              } else {
                return false;
              }
            }
          }
            else if (rules.videoConsult&&rules.videoConsult.policy){
              let dateTimeToCheck = this.user.getMoment(apt['appointmentDateTime'], 'YYYY-MM-DD HH:mm');
            if (this.validateRule(dateTimeToCheck, rules.videoConsult.policy, apt['facilityId'])) {
                   return true;
               }else{
                   return false;
               }
            }
        }
    }


  validateRule(dateTimeToCheck, txnType, facilityId) {

        var policy = txnType;
      let facilityTimezone = this.user.getFacilityTimezone(facilityId);
        var validate = true;
        var currDateTime = this.user.getMoment();

        var lowerRefDateTime = this.user.getMoment('1999-01-01');
        var upperRefDateTime = this.user.getMoment('2099-12-31');

        if (policy) {
            if (policy.minPeriod != "") {
              lowerRefDateTime = this.getRefDateTime(policy.minPeriod, policy.minPeriodUnit, policy.minPeriodFactor, dateTimeToCheck, facilityTimezone);
            }
            if (policy.maxPeriod != "") {
              upperRefDateTime = this.getRefDateTime(policy.maxPeriod, policy.maxPeriodUnit, policy.maxPeriodFactor, dateTimeToCheck, facilityTimezone);
            }
        }

        if ((currDateTime.isBefore(lowerRefDateTime)) || (currDateTime.isAfter(upperRefDateTime))) {
            validate = false;
        }

        return validate;
    }
    getRefDateTime(period, unit, direction, dateTimeToCheck, timezone) {
        var refDateTime = this.user.getMoment(dateTimeToCheck, null, null, timezone);

        if (unit == "H") {
            if (direction == "BEFORE") {
                refDateTime.subtract(parseInt(period), 'hours');
            }
            else if (direction == "AFTER") {
                refDateTime.add(parseInt(period), 'hours');
            }
        }
        else if (unit == "M") {
            if (direction == "BEFORE") {
                refDateTime.subtract(parseInt(period), 'minutes');
            }
            else if (direction == "AFTER") {
                refDateTime.add(parseInt(period), 'minutes');
            }
        }
        else if (unit == "D") {
            if (direction == "BEFORE") {
                refDateTime.subtract(parseInt(period), 'days');
            }
            else if (direction == "AFTER") {
                refDateTime.add(parseInt(period), 'days');
            }
        }
        return refDateTime;

    }

  public openOnSpotConsult() {
    this.isConsultNow = true;
  }

  // Initialize slides data similar to company-description
  private initializeSlides(data: any) {
    let slideList;
    if (data.profile && data.profile.webSlidesForLanguages) {
      slideList = data.profile.webSlidesForLanguages[this.user.currentLanguage]
      if (!slideList || !Array.isArray(slideList) || slideList.length == 0) {
        slideList = data.profile.webSlidesForLanguages['en']
        if (!slideList || !Array.isArray(slideList) || slideList.length == 0) {
          slideList = data.profile.slides
        }
      }
      else {
        slideList = data.profile.webSlidesForLanguages[this.user.currentLanguage]
      }
    }
    else {
      slideList = data.profile.webAppSlides;
    }
    
    if (slideList && Array.isArray(slideList)) {
      this.slides = slideList.map((v, i) => {
        v.slideIndex = i;
        return v;
      });
    }
  }

  // Handle banner slider clicks (replaces openPkg functionality)
  public onSlideClick(event: any) {
    console.log('Banner slide clicked:', event);
    
    if (event.type === 'package') {
      // Handle package-type slides - use existing openPkg logic
      this.pkgdetails = null;
      
      // Get directive data first
      // Use sync access since data should already be loaded
      const pkgList = this.user.getUpdateInfoSync('directives');
      if (pkgList && pkgList.userDefined && pkgList.userDefined.length > 0) {
        let userDefinedDirective = pkgList.userDefined;
          
          // Find matching service
          let matchingService = userDefinedDirective.find(s => s.code == event.serviceValue);
          
          if (matchingService) {
            if (event.packageValue) {
              // Filter to specific package
              let selectedConcept = matchingService.concepts.find(c => c.code == event.packageValue);
              if (selectedConcept) {
                this.selectedPkg = selectedConcept;
                this.selectedPkg['selectedFacilityId'] = 'JA';
              }
            }
            this.openHealthPkgs = true;
          }
        }
    } else if (event.slide && event.slide.hyperlink) {
      // Handle hyperlink clicks - already handled by banner-slider component
      console.log('Hyperlink click handled by banner-slider component');
    } else {
      // Handle generic clicks
      console.log('Generic slide click:', event.slide);
    }
  }

  public openPkg(ev: any) {
    this.pkgdetails = null;
    if(ev.toFilterPackage){
      ev.directive['concepts'].find(item => {
        if(item.code == ev.toFilterPackage){
          this.selectedPkg = item;
          this.selectedPkg['selectedFacilityId'] = 'JA'
        }
      })
      this.openHealthPkgs = true;
    }
    else{
      this.openHealthPkgs = true;
    }
  }
  public openHomeCareServices() {
    if (!this.isLoggedIn)
    return this.showLoginAlert();
    this.homeServices = true 
    this.gtmService.pushGTMEvent('Home Health Care', 'care_at_home_button');
  }
  public closehomeServices(value){
    this.homeServices = false
  }
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event['keyCode'] == 27 ) {
      this.homeServices = false
  }
  }
  
  public openReferralAppointment(referral) {
    this.isReferral = true;
    this.referralDetail = referral;
    this.openBookAppointment()
  }

    //Notification block - For future integration purpose

    public getUnReadAlertsCount() {
      this.unreadAlertCount= 0
      this.alertService.getAlerts(true).subscribe(data => {
        // if (data['status'] == "SUCCESS") {
          var events = [];
          var myalerts = [];
          if (data['events']) {
            events = data['events'].filter(function (value) {
              if (value.readStatus != 'yes')
                return value;
            });
          }
          if (data['alerts']) {
            myalerts = data['alerts'].filter(function (value) {
              if (value.readStatus != 'yes')
                return value;
            });
            let tmpUpdate;
            tmpUpdate=data['alerts'].map(a=>{
              if (a.category == 'UPDATES' && (a.updateCategory == 'SERVICEREQ' || a.updateCategory == 'PATLINK'))
                return a;
            });
            if(tmpUpdate && tmpUpdate.length>0)
            tmpUpdate=tmpUpdate.sort((a, b) => {
              return new Date(moment(b.startDate).format()).getTime() - new Date(moment(a.startDate).format()).getTime();
            })
            // tmpUpdate.sort((a,b)=>a.startDate-b.startDate);
            if(tmpUpdate.length>0 && tmpUpdate[0] && tmpUpdate[0].readStatus===''){
              this.enableAlertOnServiceUpdateNotification=true;
              this.updateAlertInfo=tmpUpdate[0];
            }
            console.log('tmp update home--',tmpUpdate,this.updateAlertInfo)
          }
          console.log('get alert count---',data,events,myalerts)
          this.unreadAlertCount = events.length + myalerts.length;
        // }
      })
    }

    public clearAlertInfo(alertInfo){
      console.log('clear')
      this.updateAlertInfo={}
      this.enableAlertOnServiceUpdateNotification = false;
      switch (alertInfo.updateCategory) {
        case 'SERVICEREQ':
          // this.navCtrl.navigateForward('/notifications');
          break;
        case 'PATLINK':
          // this.navigate('LINKEDPATIENTS', { source: 'notification', info: alertInfo })
          // this.updateAlertStatus(alertInfo, )
          break;
      }
    }

  public showLoginAlert(context?) {
    this.showPreLoginModal = true;
    this.preloginContext = context;
  }

  public showServiceRequests() {
    if (!this.isLoggedIn)
      return this.showLoginAlert();
    this.openServiceRequests = true;
  }

  public closeMyPackages() {
    this.openMyPackages = false;
    if(this.user?.getAppointmentRefNum()) {
      this.navigateToCalendar();
    }
  }

  public toggleMyPackages() {
    if(!this.isLoggedIn)
      return this.showLoginAlert();
    this.openMyPackages = true
  }

  public openContactUsModal() {
    this.showContactusModal = true
  }

  public closeLinkedPatientLimitPopup() {
    this.showLinkedPatientLimitPopup = false;
  }

  public openContactUsFromLimitPopup() {
    this.closeLinkedPatientLimitPopup();
    this.openContactUsModal();
  }

  public openManageMyFamilyFromLimitPopup() {
    this.closeLinkedPatientLimitPopup();
    this.openModal('manage-identity-modal');
  }

  public getLinkedPatientLimit() {
    return this.user.getMaxLinkedPatientCount();
  }

  public showErrorModal() {
    this.events.on(SESSION_EXPIRED, _ => {
      console.log("home SESSION_EXPIRED called")
      this.openAlertModal = true;
    });
  }
}

const referral = [{
  "personId": "031728",
  "personName": "Vidhya Palani",
  "uhid": "A200000357",
  "facilityId": "A2",
  "facilityName": "El Zohour Hospital",
  "referralEndDate": "2021-08-10",
  "referredResourceId": "DOCOPD02",
  "referredPractitionerName": "Doctor El Zohour Outpatient",
  "referredPractitionerLocalName": [{
    "locale": "en",
    "name": "Doctor El Zohour Outpatient"
  }],
  "specialityDesc": "Internal Medicine Splty",
  "specialityId": "MED"
}]
